import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgFor } from '@angular/common';

export type LanguageOption = {
  code: string;
  label: string;
};

@Component({
  selector: 'app-language-select',
  standalone: true,
  imports: [NgFor],
  templateUrl: './language-select.component.html'
})
export class LanguageSelectComponent {
  @Input({ required: true }) options: LanguageOption[] = [];
  @Input({ required: true }) value = '';
  @Output() valueChange = new EventEmitter<string>();

  protected onChange(event: Event): void {
    const select = event.target as HTMLSelectElement;
    this.valueChange.emit(select.value);
  }
}
